var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var INSERT_TEMPLATE = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation InsertTemplate($object: sequent_backend_template_insert_input!) {\n        insert_sequent_backend_template(objects: [$object]) {\n            affected_rows\n        }\n    }\n"], ["\n    mutation InsertTemplate($object: sequent_backend_template_insert_input!) {\n        insert_sequent_backend_template(objects: [$object]) {\n            affected_rows\n        }\n    }\n"])));
var templateObject_1;
